var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreditCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CreditCard"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.125 4.5H3.125C2.72718 4.5 2.34564 4.65804 2.06434 4.93934C1.78304 5.22064 1.625 5.60218 1.625 6V9.08438V17.9906C1.625 18.3884 1.78304 18.77 2.06434 19.0513C2.34564 19.3326 2.72718 19.4906 3.125 19.4906H21.125C21.5228 19.4906 21.9044 19.3326 22.1857 19.0513C22.467 18.77 22.625 18.3884 22.625 17.9906V6C22.625 5.60218 22.467 5.22064 22.1857 4.93934C21.9044 4.65804 21.5228 4.5 21.125 4.5ZM12.875 16.5H11.375C11.1761 16.5 10.9853 16.421 10.8447 16.2803C10.704 16.1397 10.625 15.9489 10.625 15.75C10.625 15.5511 10.704 15.3603 10.8447 15.2197C10.9853 15.079 11.1761 15 11.375 15H12.875C13.0739 15 13.2647 15.079 13.4053 15.2197C13.546 15.3603 13.625 15.5511 13.625 15.75C13.625 15.9489 13.546 16.1397 13.4053 16.2803C13.2647 16.421 13.0739 16.5 12.875 16.5ZM18.875 16.5H15.875C15.6761 16.5 15.4853 16.421 15.3447 16.2803C15.204 16.1397 15.125 15.9489 15.125 15.75C15.125 15.5511 15.204 15.3603 15.3447 15.2197C15.4853 15.079 15.6761 15 15.875 15H18.875C19.0739 15 19.2647 15.079 19.4053 15.2197C19.546 15.3603 19.625 15.5511 19.625 15.75C19.625 15.9489 19.546 16.1397 19.4053 16.2803C19.2647 16.421 19.0739 16.5 18.875 16.5ZM3.125 8.33438V6H21.125V8.33438H3.125Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/credit-card.54015525a9989685b858c0659c4f1fa0.svg";
export { ForwardRef as ReactComponent };